import { Button, Grid, Typography } from "@mui/material";
import React from "react";
/* import ProzoDataGrid from "../../../common/ProzoDataGrid";
import { formatDate } from "../../../helpers/UtilityHelper"; */

const ViewImages = (props) => {
  const { row } = props;

  return (
    <>
      {row?.map((item, index) => (
        <Grid container rowSpacing={2} key={index}>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography>Image {index + 1}</Typography>
            <Button onClick={() => window.open(item.signedLink, "_blank")}>
              View
            </Button>
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default ViewImages;